<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <li class="currentNode"><a>驻京党建</a></li>
            </ul>
            <div class="page-main">
                <div class="page-content">
                    <h3>驻京党建</h3>
                    <el-table
                        :data="tableData"
                        style="width: 100%"
                        :show-header="false">
                        <el-table-column
                            label="点"
                            width="10">
                            <template slot-scope="">
                                <span class="dot"></span>
                            </template>
                        </el-table-column>
                        <el-table-column
                            label="内容">
                            <template slot-scope="scope">
                                <a class="table_a" @click="goDetail(scope.row)">
                                    <p class="ellipsis_one">{{ scope.row.Title }}</p>
                                </a>
                            </template>
                        </el-table-column>
                        <el-table-column
                            prop="UpdateTime"
                            label="日期"
                            width="120">
                        </el-table-column>
                    </el-table>
                    <el-pagination
                        background
                        layout="prev, pager, next"
                        :total="total"
                        :current-page="currentPage"
                        :page-size="pageSize"
                        @current-change="handleCurrentChange">
                    </el-pagination>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import {
    getDangjianList
} from '@services/indexService.js';

export default {
    name:"",
    data() {
        return {
            type: 1, //协会党建1，党建要求2，会员单位党建3
            total: 0,
            currentPage: 1,
            pageSize: 10,
            tableData: [],
        }
    },
    created() {
        this.type = this.$route.query.type;
        if (this.$route.query.page) {
            this.currentPage = Number(this.$route.query.page);
        }
        this.getDangjianList();
    },
    methods: {
        getDangjianList() {
            let params = {
                current: this.currentPage,
                size: this.pageSize,
                type: this.type
            };
            getDangjianList(params).then(res => {
                console.log(res);
                if (res.Code == 1) {
                    this.tableData = [...res.Data];
                    this.total = res.Count;
                } else {
                    this.$message.error("驻京党建请求失败");
                }
            })
        },
        handleCurrentChange(pageNum) {
            this.currentPage = pageNum;
            this.getDangjianList();
        },
        goDetail(data) {
            let newUrl = this.$router.resolve({
                path:'/layout/association-party-detail',
                query: {
                    id: data.Id,
                    page: this.currentPage,
                }
            });
            window.open(newUrl.href, '_blank');
        }
    }
}
</script>

<style scoped>
.page-content {
    width: 1280px;
    padding: 30px;
}
.page-content h3{
    text-align:center;
}
.table_a {
    cursor: pointer;
}
</style>